import type { HourlyWeatherSample, UnitsMode, WeatherLayer } from '../types';
import { formatTemp, formatWind } from './units';

export const TICKER_LAYERS: { id: WeatherLayer; label: string; ariaLabel: string }[] = [
  { id: 'temp', label: 'Temp', ariaLabel: 'Temperature' },
  { id: 'wind', label: 'Wind', ariaLabel: 'Wind' },
  { id: 'precip', label: 'Precipitation', ariaLabel: 'Chance of precipitation' },
];

export type TickerMetricResult = {
  text: string;
  ariaLabel: string;
  missing: boolean;
};

/** Format the single metric shown on a route ticker. Nulls stay "—"; precip is chance, never amount. */
export function formatTickerMetric(
  layer: WeatherLayer,
  weather: HourlyWeatherSample | undefined,
  unitsMode: UnitsMode,
): TickerMetricResult {
  if (!weather) {
    return { text: '—', ariaLabel: 'Weather unavailable', missing: true };
  }

  if (layer === 'temp') {
    if (weather.temperatureC == null) {
      return { text: '—', ariaLabel: 'Temperature unavailable', missing: true };
    }
    const text = formatTemp(weather.temperatureC, unitsMode);
    return { text, ariaLabel: `Temperature ${text}`, missing: false };
  }

  if (layer === 'wind') {
    if (weather.windKmh == null) {
      return { text: '—', ariaLabel: 'Wind unavailable', missing: true };
    }
    const text = formatWind(weather.windKmh, unitsMode);
    return { text, ariaLabel: `Wind ${text}`, missing: false };
  }

  if (weather.precipProbability == null) {
    return { text: '—', ariaLabel: 'Chance of precipitation unavailable', missing: true };
  }
  const pct = Math.round(weather.precipProbability);
  return {
    text: `${pct}%`,
    ariaLabel: `${pct}% chance of precipitation`,
    missing: false,
  };
}
